const BANNER_SELECTOR = ".shopify-pc__banner__dialog";
const FULL_WIDTH_LAYOUT_ATTRIBUTE = "data-full-width-layout";
const MOBILE_LAYOUT_ATTRIBUTE = "data-mobile-layout";
const LAYOUT_ATTRIBUTE = "data-theme-cookie-layout";
const MEASURING_ATTRIBUTE = "data-theme-cookie-measuring";
const READY_ATTRIBUTE = "data-theme-cookie-ready";
const MAX_WIDTH_ATTRIBUTE = "data-theme-cookie-max-width";
const MAX_WIDTH_PROPERTY = "--theme-cookie-max-width";
const OBSERVER_TIMEOUT = 1e4;
const RESIZE_DEBOUNCE = 150;
const MOBILE_BREAKPOINT = 991.98;
const CENTER_TOLERANCE = 8;
const FULL_WIDTH_TOLERANCE = 2;
function detectLayout(dialog) {
  const rect = dialog.getBoundingClientRect();
  if (rect.width === 0 || rect.height === 0) return null;
  const viewportWidth = document.documentElement.clientWidth;
  const viewportHeight = document.documentElement.clientHeight;
  const centerX = rect.left + rect.width / 2;
  const centerY = rect.top + rect.height / 2;
  const usesFullWidthLayout = viewportWidth <= MOBILE_BREAKPOINT ? dialog.hasAttribute(MOBILE_LAYOUT_ATTRIBUTE) : dialog.hasAttribute(FULL_WIDTH_LAYOUT_ATTRIBUTE);
  if (usesFullWidthLayout) {
    return "bottom-full-width";
  }
  if (Math.abs(centerY - viewportHeight / 2) <= CENTER_TOLERANCE) {
    return "center";
  }
  if (rect.width >= viewportWidth - FULL_WIDTH_TOLERANCE) {
    return "bottom-full-width";
  }
  const leftGap = rect.left;
  const rightGap = viewportWidth - rect.right;
  if (Math.abs(centerX - viewportWidth / 2) <= CENTER_TOLERANCE) {
    return "bottom-center";
  }
  return leftGap < rightGap ? "bottom-left" : "bottom-right";
}
function getMaxWidthInRem(dialog) {
  const maxWidth = getComputedStyle(dialog).maxWidth;
  if (!maxWidth.endsWith("px")) return null;
  const maxWidthInPixels = Number.parseFloat(maxWidth);
  const rootFontSize = Number.parseFloat(
    getComputedStyle(document.documentElement).fontSize
  );
  if (!Number.isFinite(maxWidthInPixels) || !Number.isFinite(rootFontSize) || rootFontSize === 0) {
    return null;
  }
  return `${Number((maxWidthInPixels / rootFontSize).toFixed(4))}rem`;
}
function resetThemeLayout(dialog) {
  if (!dialog.hasAttribute(MEASURING_ATTRIBUTE)) {
    dialog.setAttribute(MEASURING_ATTRIBUTE, "");
  }
  dialog.style.removeProperty(MAX_WIDTH_PROPERTY);
  dialog.removeAttribute(MAX_WIDTH_ATTRIBUTE);
  dialog.removeAttribute(LAYOUT_ATTRIBUTE);
}
function syncLayout(dialog) {
  if (!dialog.isConnected) return;
  resetThemeLayout(dialog);
  const layout = detectLayout(dialog);
  if (!layout) return;
  const maxWidthInRem = getMaxWidthInRem(dialog);
  if (maxWidthInRem) {
    dialog.style.setProperty(MAX_WIDTH_PROPERTY, maxWidthInRem);
    dialog.setAttribute(MAX_WIDTH_ATTRIBUTE, "");
  }
  dialog.setAttribute(LAYOUT_ATTRIBUTE, layout);
  requestAnimationFrame(() => {
    if (!dialog.isConnected || dialog.getAttribute(LAYOUT_ATTRIBUTE) !== layout || !dialog.hasAttribute(MEASURING_ATTRIBUTE)) {
      return;
    }
    dialog.setAttribute(READY_ATTRIBUTE, "");
    dialog.removeAttribute(MEASURING_ATTRIBUTE);
  });
}
function setupResponsiveSync(dialog) {
  let resizeTimeout;
  let initialSyncComplete = false;
  if (!dialog.hasAttribute(MEASURING_ATTRIBUTE)) {
    dialog.setAttribute(MEASURING_ATTRIBUTE, "");
  }
  const runInitialSync = () => {
    if (initialSyncComplete) return;
    const rect = dialog.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return;
    initialSyncComplete = true;
    initialSizeObserver.disconnect();
    syncLayout(dialog);
  };
  const initialSizeObserver = new ResizeObserver(([entry]) => {
    if (entry.contentRect.width === 0 || entry.contentRect.height === 0) return;
    runInitialSync();
  });
  const handleResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (!dialog.isConnected) {
        window.removeEventListener("resize", handleResize);
        return;
      }
      setTimeout(() => syncLayout(dialog), 0);
    }, RESIZE_DEBOUNCE);
  };
  window.addEventListener("resize", handleResize, { passive: true });
  initialSizeObserver.observe(dialog);
  setTimeout(runInitialSync, 0);
}
function findBanner(node) {
  if (!(node instanceof Element)) return null;
  if (node.matches(BANNER_SELECTOR)) return node;
  return node.querySelector(BANNER_SELECTOR);
}
function initializeBanner() {
  const existingBanner = document.querySelector(BANNER_SELECTOR);
  if (existingBanner) {
    setupResponsiveSync(existingBanner);
    return;
  }
  let observerTimeout;
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        const banner = findBanner(node);
        if (!banner) continue;
        clearTimeout(observerTimeout);
        observer.disconnect();
        setupResponsiveSync(banner);
        return;
      }
    }
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  observerTimeout = setTimeout(() => observer.disconnect(), OBSERVER_TIMEOUT);
}
if (document.body.hasAttribute("data-user-presence")) {
  initializeBanner();
} else {
  const presenceObserver = new MutationObserver(() => {
    if (!document.body.hasAttribute("data-user-presence")) return;
    presenceObserver.disconnect();
    initializeBanner();
  });
  presenceObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ["data-user-presence"]
  });
}
